var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.repoUrl && _vm.hash)?_c('span',{staticClass:"version-badge"},[_c('a',{attrs:{"href":_vm.commitOnRemote,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.shortHash))]),_c('AxRetry',{attrs:{"interval":_vm.interval,"handler":_vm.pollApiVersionInfo,"immediate":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }